import * as React from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { PageProperties } from "src/interfaces";
import { ArticlePreview } from "src/components/articlePreview";
import { toHTML } from "@portabletext/to-html";
import LoadingSpinner from "src/components/loading";
import { SiteModel } from "src/model/model";
import { fetchArticles, SchemaType } from "src/modules/sanityApi";
import { calculateAnimationDelay } from "src/scripts/utility";
import { SocialMediaLink } from "src/components/socialMediaLink";
import { socialMediaHome } from "public/data/socialMedia";

import "src/styles/home.css";
import { PageTitle } from "src/components/pageTitle";

interface HomeProperties extends PageProperties {
    socialMediaData: {slug: string, link: string}[];
    // newsPosts: object;
}

export const Home = observer(({session}: {session: SiteModel}) => {
    // useEffect(() => {
    //     const fetchPosts = async () => {
    //         if (!session.articlesHaveLoaded || session.numberOfArticles < 3) {
    //             try {
    //                 const fetchedPosts = await fetchArticles(SchemaType.Article);
    //                 session.addArticles(fetchedPosts);
    //                 console.log(fetchedPosts);
    //             } catch (error) {
    //                 console.error("Error fetching posts:", error);
    //             }
    //         }
    //     };

    //     fetchPosts();
    // }, [session]);

    return (
        <HomeView
            title="Home"
            style="home_page.css"
            socialMediaData={socialMediaHome}
            // newsPosts={session.newsArticles.slice(0, 3)}
        />
    );
});

export function HomeView(props: HomeProperties){

    return (<>
    <PageTitle pageTitle="Home"/>
    <section className="home-section-front">
        <div className="home-logo-container scale-in">
            <img className="home-logo" aria-hidden="true" src="/images/logo/logo_main.png"/>
            <img 
            className="home-logo-glint" 
            aria-hidden="true" 
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACAAQMAAAD58POIAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNpjYBgFo2AUjIJRMApGwSigLwAACIAAAcNXzB0AAAAASUVORK5CYII="
            />
        </div>
    </section>

    <section className="home-section-main">
        <main className="main-home standard-width">

            <div className="kickstarter-wrapper">
                <a href="https://www.kickstarter.com/projects/dreamfloweridols/dream-flower-idols" target="_blank">
                <img src="/images/misc/kickstarter.png"></img>
                </a>

            </div>


            <p className="front-description">Dream Flower Idols is an online idol project that creates original music, animation and storytelling. <br/>Our main goal is to create music that inspires others to reach for their dreams.</p>
            <div className="link-container">
                {props.socialMediaData.map((social, index, array) => {
                    return (
                    <React.Fragment key={social.slug}>
                        <SocialMediaLink
                        to={social.link}
                        className="slide-top fade-in"
                        platform={social.slug}
                        style={{animationDelay: calculateAnimationDelay(index, array.length, 300, 250)}}
                        />
                    </React.Fragment>
                )
                })}
            </div>
            <div className="news-discord-container">
                {/* <div className="news-container news-container-home"> */}
                    {/* <p className="news-heading">Latest News</p> */}
                    {/* <iframe id="twitter-widget-0" scrolling="no" frameBorder="0" allowtransparency="true" allowFullscreen="true" className="" title="Twitter Timeline" src="https://syndication.twitter.com/srv/timeline-profile/screen-name/DreamFlowerIdol?dnt=false&embedId=twitter-widget-0&features=eyJ0ZndfdGltZWxpbmVfbGlzdCI6eyJidWNrZXQiOltdLCJ2ZXJzaW9uIjpudWxsfSwidGZ3X2ZvbGxvd2VyX2NvdW50X3N1bnNldCI6eyJidWNrZXQiOnRydWUsInZlcnNpb24iOm51bGx9LCJ0ZndfdHdlZXRfZWRpdF9iYWNrZW5kIjp7ImJ1Y2tldCI6Im9uIiwidmVyc2lvbiI6bnVsbH0sInRmd19yZWZzcmNfc2Vzc2lvbiI6eyJidWNrZXQiOiJvbiIsInZlcnNpb24iOm51bGx9LCJ0ZndfZm9zbnJfc29mdF9pbnRlcnZlbnRpb25zX2VuYWJsZWQiOnsiYnVja2V0Ijoib24iLCJ2ZXJzaW9uIjpudWxsfSwidGZ3X21peGVkX21lZGlhXzE1ODk3Ijp7ImJ1Y2tldCI6InRyZWF0bWVudCIsInZlcnNpb24iOm51bGx9LCJ0ZndfZXhwZXJpbWVudHNfY29va2llX2V4cGlyYXRpb24iOnsiYnVja2V0IjoxMjA5NjAwLCJ2ZXJzaW9uIjpudWxsfSwidGZ3X3Nob3dfYmlyZHdhdGNoX3Bpdm90c19lbmFibGVkIjp7ImJ1Y2tldCI6Im9uIiwidmVyc2lvbiI6bnVsbH0sInRmd19kdXBsaWNhdGVfc2NyaWJlc190b19zZXR0aW5ncyI6eyJidWNrZXQiOiJvbiIsInZlcnNpb24iOm51bGx9LCJ0ZndfdXNlX3Byb2ZpbGVfaW1hZ2Vfc2hhcGVfZW5hYmxlZCI6eyJidWNrZXQiOiJvbiIsInZlcnNpb24iOm51bGx9LCJ0ZndfdmlkZW9faGxzX2R5bmFtaWNfbWFuaWZlc3RzXzE1MDgyIjp7ImJ1Y2tldCI6InRydWVfYml0cmF0ZSIsInZlcnNpb24iOm51bGx9LCJ0ZndfbGVnYWN5X3RpbWVsaW5lX3N1bnNldCI6eyJidWNrZXQiOnRydWUsInZlcnNpb24iOm51bGx9LCJ0ZndfdHdlZXRfZWRpdF9mcm9udGVuZCI6eyJidWNrZXQiOiJvbiIsInZlcnNpb24iOm51bGx9fQ%3D%3D&frame=false&hideBorder=true&hideFooter=true&hideHeader=true&hideScrollBar=true&lang=en&maxHeight=300px&origin=https%3A%2F%2Ffirststage-pro.com%2Fen%2F&sessionId=a5e18e4d8716997d83d57ed760b57d89a3ca8711&showHeader=false&showReplies=false&theme=light&transparent=false&widgetsVersion=2615f7e52b7e0%3A1702314776716" style={{position: "static", visibility: "visible", width: "327px", height: "300px", display: "block", flexGrow: 1}}></iframe> */}
                    {/* <a className="twitter-timeline" href="https://twitter.com/DreamFlowerIdol?ref_src=twsrc%5Etfw">Tweets by DreamFlowerIdol</a> */}
                    {/*{
                        props.newsPosts ?
                        (props.newsPosts as Array<any>).map(post => {
                            return <React.Fragment key={post.slug.current}>
                                <ArticlePreview 
                                title={post.title} 
                                slug={post.slug.current}
                                body={toHTML(post.body)}
                                date={post.publishedAt}
                                image={post.image}
                                />
                            </React.Fragment>
                        })
                        : <LoadingSpinner className="loading-big"/>
                    }
                    <Link to="/news" className="link-text">See all news</Link> */}
                {/* </div> */}
                
                <div className="discord">
                    <p style={{color:"var(--discord_blue)"}}>Join Our Discord!</p>
                    <div className="discord-container">
                        <iframe className="discord-widget" src="https://discord.com/widget?id=848365664103432192&theme=light" width="350" height="500" allowtransparency="true" frameBorder="0" sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts" title="Discord Widget"/>
                    </div>
                </div>
            </div>
        </main>
    </section>
    </>
    )
}
